class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open on hover (desktop, pointer: fine) and close when leaving the area
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Toggle active state on the top-level menu summary
    const summaryEl = this.mainDetailsToggle.querySelector('summary.header__menu-item');
    if (summaryEl) {
      summaryEl.classList.toggle('is-active', this.mainDetailsToggle.open);
      summaryEl.setAttribute('aria-expanded', this.mainDetailsToggle.open ? 'true' : 'false');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  shouldUseHover() {
    // Only enable hover on desktop and devices that actually support hover
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    const canHover = window.matchMedia('(hover: hover)').matches;
    const finePointer = window.matchMedia('(pointer: fine)').matches;
    return desktop && canHover && finePointer;
  }

  onMouseEnter() {
    if (!this.shouldUseHover()) return;
    // Close any other open header menus to avoid multiple open menus
    document.querySelectorAll('header-menu details[open]').forEach((el) => {
      if (el !== this.mainDetailsToggle) el.open = false;
    });
    // Open this menu
    if (!this.mainDetailsToggle.open) this.mainDetailsToggle.open = true;
    const summaryEl = this.mainDetailsToggle.querySelector('summary.header__menu-item');
    if (summaryEl) summaryEl.setAttribute('aria-expanded', 'true');
  }

  onMouseLeave() {
    if (!this.shouldUseHover()) return;
    // Close the menu when leaving the entire header-menu area
    if (this.mainDetailsToggle.open) this.close();
  }
}

customElements.define('header-menu', HeaderMenu);
